import { render, staticRenderFns } from "./github-customers.vue?vue&type=template&id=0ba02ce9&scoped=true"
import script from "./github-customers.js?vue&type=script&lang=js&external"
export * from "./github-customers.js?vue&type=script&lang=js&external"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba02ce9",
  null
  
)

export default component.exports